"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "novellara": {
    "aba05d9a": [{
      "hkey": "a83bb3b3",
      "slug": "novellara",
      "name": "Novellara",
      "primary": true,
      "skipSearch": false
    }],
    "minghella": [{
      "hkey": "a83bb3b3",
      "slug": "novellara",
      "name": "Novellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84f33e01": [{
      "hkey": "a83bb3b3",
      "slug": "novellara",
      "name": "Novellara",
      "primary": true,
      "skipSearch": false
    }],
    "mulino-di-sotto": [{
      "hkey": "a83bb3b3",
      "slug": "novellara",
      "name": "Novellara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "166d8d13": [{
      "hkey": "179117e1",
      "slug": "santa-maria-della-fossa-san-giovanni-della-fossa",
      "name": "Santa Maria della Fossa-San Giovanni della Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni-della-fossa": [{
      "hkey": "179117e1",
      "slug": "santa-maria-della-fossa-san-giovanni-della-fossa",
      "name": "Santa Maria della Fossa-San Giovanni della Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "novellara"
    }],
    "6e21bbc8": [{
      "hkey": "179117e1",
      "slug": "santa-maria-della-fossa-san-giovanni-della-fossa",
      "name": "Santa Maria della Fossa-San Giovanni della Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "179117e1",
      "slug": "santa-maria-della-fossa-san-giovanni-della-fossa",
      "name": "Santa Maria della Fossa-San Giovanni della Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;